module.exports = __webpack_public_path__ + "img/calenda-chevron-right.3f9f8169.svg";